import * as Yup from 'yup';

import { type FieldSchema, type ValidatorContext } from '../types';

const createSingleSelectValidator = (
  context: ValidatorContext
): FieldSchema => {
  const { field, l, isRequired, requiredMessage } = context;

  let validator = Yup.mixed().nullable();

  if (isRequired && 'isReadOnly' in field && !field.isReadOnly) {
    const message = requiredMessage ?? l('This field is required');

    validator = validator.test('required', message, (value) => {
      if (!value) {
        return false;
      }

      if (typeof value === 'object') {
        if (Object.keys(value).length === 0) {
          return false;
        }

        if ('value' in value) {
          return Boolean(value.value) && value.value !== '';
        }
      }

      return Boolean(value) && value !== '';
    });
  }

  return validator;
};

export default createSingleSelectValidator;
